import React from "react";
import loadable from "@loadable/component";
import PageLoader from "../../../components/PageLoader";

export default loadable(e => import("./memory-home"), { fallback: <PageLoader /> });
